var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"my-account"}},[_c('left-panel'),_c('router-view',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'push-right-for-left-panel' : ''})],1)}
var staticRenderFns = []

export { render, staticRenderFns }